module.exports = __webpack_public_path__ + "static/media/mobile-welcome2.7c579541.png";